import axios from "axios";
import { toast } from 'react-toastify';
import appSettings from "../app-settings";

export const configAxios = () => {
  axios.defaults.baseURL = appSettings.apiPath;
  axios.interceptors.request.use(function (config) {
    const token = `Bearer ${localStorage.getItem("accessToken")}`;
    config.headers.Authorization = token;

    return config;
  });

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response && (error.response.status === 400)) {
        // custom BadRequest messages that guides the user into the direction (return BadRequest("message"))
        toast.error(`${error.response.data}`);
      } else if (error.response.status === 401) {
        location.reload(); // reload to force re-authentication
      } else {
        toast.error(`${error.message}`);
      }

      return Promise.reject(error);
    }
  );
};
